<div class="login-modal-content">
  <div class="modal-login">
    <div class="background-white">
      <h1 class="portal-title">{{ 'selectPortal.title' | translate }}</h1>

      <div class="form-group">
        <div class="combobox" [class.open]="isOpen">
          <div class="combobox-input-wrapper" (click)="openDropdown()">
            <input
              type="text"
              class="combobox-input"
              [value]="displayValue"
              (input)="onInputChange($event.target['value'])"
              [placeholder]="selectedPortal ? '' : ('selectPortal.placeholder' | translate)"
              autocomplete="off"
              />
              <span class="combobox-chevron" [class.rotated]="isOpen">&#x25BE;</span>
            </div>

            @if (isOpen) {
              <ul class="combobox-dropdown">
                @for (portal of filteredPortals; track portal) {
                  <li
                    class="combobox-option"
                    [class.selected]="selectedPortal?.id === portal.id"
                    (click)="selectPortal(portal)"
                    >
                    {{ portal.name }}
                  </li>
                }
                @if (filteredPortals.length === 0) {
                  <li class="combobox-empty">
                    {{ 'selectPortal.noResults' | translate }}
                  </li>
                }
              </ul>
            }
          </div>
        </div>

        <button
          class="enter-button"
          [disabled]="!selectedPortal"
          (click)="enterPortal()"
          >
          {{ 'selectPortal.enterButton' | translate }}
        </button>

        @if (portals.length === 0) {
          <div class="no-portals">
            {{ 'selectPortal.noPortals' | translate }}
          </div>
        }
      </div>
    </div>
  </div>
